import React from "react";
import "../styles/header.css"

function Header() {
  return (
    <header className="header">
      <h2 className="heading">Employee Directory</h2>
     
    </header>
  )
}

export default Header;